import {
  administrative,
  declareFieldMeanings,
  identity,
  means,
} from '../../../src/issues/field-meanings';

/** What each Public Works street-use permit detail means to an owner. */
const WINDOW = 'changes when the street work may happen';
export const fieldMeanings = declareFieldMeanings({
  sources: ['public-works'],
  declarations: [
    identity(
      'address',
      'Permit number',
      'Published permit address',
      'Street block',
      'Street segment ID',
    ),
    administrative('Location note', 'Utility type'),
    means(
      'detail',
      'whether the permit is listed at this address or only on its block',
      ['Location scope', 'locationScope'],
      { matters: 'changes whether the permit concerns this property' },
    ),
    means('status', 'the permit status', ['status', 'Status']),
    means('date', 'the permit date', ['date']),
    means('date', 'the approval date', ['Approved']),
    means('deadline', 'the start of the permit window', ['Permit window start'], {
      matters: WINDOW,
    }),
    means('deadline', 'the end of the permit window', ['Permit window end'], { matters: WINDOW }),
    means('description', 'the described work', ['description', 'Work'], {
      matters: 'reworded what the permit allows',
      means:
        'This is the work the permit describes. A change means the city reworded what the permit allows.',
    }),
    means('description', 'the stated purpose', ['Purpose'], {
      matters: 'reworded why the work is needed',
      means:
        'This is the stated purpose of the work. A change means the city reworded why it is needed.',
    }),
    means('detail', 'the permit type', ['Permit type']),
    means('detail', 'the permit holder', ['Permit holder'], {
      matters: 'changes who is allowed to do the work',
    }),
  ],
});
